<template>
  <Modal v-model="show" footer-hide>
    <Row>
      <Col span="12">
        <Select
          v-model="selectedFixedJournalListId"
          not-found-text="定型文リストがまだ存在しません"
          placeholder="定型文リストを選択"
        >
          <Option
            v-for="list in fixedJournalLists.filter(
              (l) => l.channel_id == currentChannelId
            )"
            :value="list.id"
            :key="list.id"
          >
            {{ list.name }}
          </Option>
        </Select>
      </Col>
    </Row>
    <span v-if="exceededRemainingCapacity" class="red"
      >追加可能な数を超えています</span
    >
    <Row>
      <Col span="24">
        <List v-if="selectedFixedJournalListId != -1" border>
          <ListItem class="head">
            <Checkbox v-model="checkedAll">
              全選択
              <!-- {{ selectedFixedJournalList.name }} -->
            </Checkbox>
          </ListItem>
          <CheckboxGroup v-model="checkedFixedJournals">
            <ListItem
              v-for="fixedJournal in selectedFixedJournalList.fixed_journals.sort((i, j) => i.order - j.order)"
              :key="fixedJournal.id"
            >
              <Checkbox :label="fixedJournal.id">
                {{ omitDisplayName(fixedJournal.name) }}
              </Checkbox>
            </ListItem>
          </CheckboxGroup>
        </List>
        <List v-else>
          <div style="background: #eee; padding: 100px">
            ここに選択した定型文リストが表示されます
          </div>
        </List>
      </Col>
    </Row>
    <Row style="margin: 24px 0 0">
      <Col span="24">
        <Button type="text" @click="clear">キャンセル</Button>
        <Button
          type="primary"
          style="float: right"
          @click="createMultipleMaterials"
          :disabled="
            checkedFixedJournals.length == 0 || exceededRemainingCapacity
          "
        >
          素材に追加する
        </Button>
      </Col>
    </Row>
  </Modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      show: false,
      selectedFixedJournalListId: -1,
      checkedAll: false,
      checkedFixedJournals: [],
    }
  },
  watch: {
    target(val) {
      if (val) {
        this.show = true
        // デフォルトでは定型文リストを非選択とする
        // this.selectedFixedJournalListId = this.getDefaultFixedJournalListId()
      } else {
        this.show = false
      }
    },
    show(val) {
      if (!val) {
        this.unsetTarget()
      }
    },
    checkedAll(val) {
      if (val) {
        this.selectedFixedJournalList.fixed_journals.forEach((i) =>
          this.checkedFixedJournals.push(i.id)
        )
      } else {
        this.checkedFixedJournals.splice(0)
      }
    },
  },
  computed: {
    ...mapGetters(['fixedJournalLists']),
    ...mapGetters({
      target: 'fixedJournals/fixedJournalAcceptModalTarget',
      remainingCapacity:
        'fixedJournals/fixedJournalAcceptModalRemainingCapacity',
    }),
    currentChannelId() {
      return this.$route.params.channelId
    },
    selectedFixedJournalList() {
      const res = this.fixedJournalLists.find(
        (i) => i.id == this.selectedFixedJournalListId
      )
      if (!res) {
        return []
      }
      return res
    },
    exceededRemainingCapacity() {
      return this.checkedFixedJournals.length - this.remainingCapacity > 0
    },
  },
  methods: {
    ...mapActions({
      unsetTarget: 'fixedJournals/unsetFixedJournalAcceptModalTarget',
    }),
    getDefaultFixedJournalListId() {
      if (this.fixedJournalLists.length == 0) {
        return -1
      }
      const candidate = this.fixedJournalLists.find((i) => i.id)
      return candidate ? candidate.id : this.fixedJournalLists[0].id
    },
    clear() {
      this.show = false
      this.checkedAll = false
      this.checkedFixedJournals.splice(0)
    },
    createMultipleMaterials() {
      const fixedJournals = []
      this.selectedFixedJournalList.fixed_journals.forEach((fj) => {
        if (this.checkedFixedJournals.find((id) => id == fj.id)) {
          fixedJournals.push(fj)
        }
      })
      const material_group_id = this.target.id
      const journals = fixedJournals.map((fj) => {
        return fj.name
      })
      this.$store.dispatch('batchCreateMaterialOrdered', {
        ...this.$route.params,
        materialInputs: {
          material_group_id,
          journals
        }
      })
      this.clear()
    },
    omitDisplayName(name) {
      if (name.length > 70) {
        return name.substring(0, 69) + '...'
      }
      return name
    },
  },
}
</script>
<style lang="less" scoped>
.head {
  border: 1px solid #dcdee2;
  background-color: #eee;
  margin-top: -1px;
}
</style>
